itsoftApp.createModule("video", function () {
    const module = this;
    const videoItemEls = document.querySelectorAll(".js-video-item");
    const videoEls = document.querySelectorAll("video");

    if (videoEls.length > 0) {
        videoEls.forEach(function (videoEl) {
            videoEl.setAttribute("controlslist", "nodownload");
        });
    }

    const initVideo = function (videoEl) {
        const videoBlockWrapper = videoEl.querySelector(".js-video-container");
        const videoItem = videoEl.querySelector(".js-video-item");
        const playButtons = videoEl.querySelectorAll(".js-button-play");

        var onVideoPlay = function () {
            videoItem.onplay = function () {
                videoItemEls.forEach((el) => {
                    if (el === videoItem) {
                        videoItem.play();
                    } else {
                        el.pause();
                    }
                });
            }

            videoItem.play();
            videoEl.classList.add("js-inited");
            videoItem.classList.add("js-active");
            videoBlockWrapper.classList.add("js-active");
        }

        playButtons.forEach((playButton) => {
            playButton.addEventListener("click", onVideoPlay);
        })
    }

    const videoPlay = function (videoItem) {
        videoItem.play();
    }

    const videoStop = function (videoItem) {
        videoItem.pause();
    }

    module.initVideo = initVideo;
    module.videoPlay = videoPlay;
    module.videoStop = videoStop;
});